import { Routes } from "../../app/router/Routes";

const prefix = (route: string) => Routes.HR + route;

export const HrRoutes = {
    DASHBOARD: prefix("/dashboard"),
    EVIDENCE: prefix("/evidence"),
    REJECTED: prefix("/rejected"),
    JOB_CATEGORIES: {
        ROOT: prefix("/job-categories"),
        DETAILS: prefix("/job-categories/:jobCategoryId")
    },
    APPLICANT: {
        ROOT: prefix("/applicant/:applicantId"),
        DETAILS: prefix("/applicant/:applicantId/details"),
        DOCUMENTS: prefix("/applicant/:applicantId/documents"),
        NOTES: prefix("/applicant/:applicantId/notes"),
        HISTORY: prefix("/applicant/:applicantId/history")
    }
};
